module.exports = __webpack_public_path__ + "img/vrify_header.64bb1d55.png";